// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"348":"base","535":"login"}[chunkId] + "." + {"348":"f6aaf0bc","535":"1ea6defc"}[chunkId] + ".css";
};